import React, { useState, useEffect } from 'react';
import Dashboard from './Dashboard.jsx';
import Login from './Login.jsx';
import { parseAndValidateIdToken } from './utils/auth';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // central logout/auth-expired handler
  const handleLogout = () => {
    console.log('Logging out user due to auth expiration or logout request');
    localStorage.removeItem('google_id_token');
    setIsAuthenticated(false);
  };

  // initial token check on load
  useEffect(() => {
    const token = localStorage.getItem('google_id_token');
    if (parseAndValidateIdToken(token)) {
      setIsAuthenticated(true);
    } else {
      handleLogout();
    }
  }, []);

  return (
    isAuthenticated ? (
      <Dashboard onAuthExpired={handleLogout} />
    ) : (
      <Login onLogin={() => setIsAuthenticated(true)} />
    )
  );
};

export default App;
